import { useQuery } from "@tanstack/react-query"

import { httpClient } from "utils/infrastructure/httpClient"
import { isBrowser } from "utils/infrastructure/ssg-utils"

const GET_BANNER_SETTINGS = "GET_BANNER_SETTINGS"

interface BannerResponse {
    name: string
}
type BannersResponse = BannerResponse[]

function getBanners(page: string) {
    return httpClient.get<BannersResponse>(`/banner/client${page}`)
}

export function useGetBanners() {
    const page = isBrowser() ? document.location.pathname : ""
    return useQuery<BannersResponse>([GET_BANNER_SETTINGS, page], () => getBanners(page), {
        refetchOnWindowFocus: false,
    })
}
